
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaHome, FaInfoCircle, FaDollarSign, FaSignInAlt, FaSignOutAlt, FaBars, FaTimes } from 'react-icons/fa';
import '../css/Header.css';

const Header = ({ isLoggedIn, onLogout }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token && window.location.pathname === '/variation') {
      navigate('/login-User');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userId');
    onLogout();
    window.location.href = 'https://postlii.com/login-User';
  };

  return (
    <div className="header-container">
      <header className="header-inner">
        <div className="logo">
          <img src="https://admin.postlii.com/Uploads/logo.jpeg" alt="Logo" className="logo-img" />
          <span>Baners</span>
        </div>

        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
        </div>

        <nav className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <ul>
            <li>
              <Link to="/Variations/variation" onClick={() => setMenuOpen(false)}>
                <FaHome className="nav-icon" /> Home
              </Link>
            </li>
            <li>
              <Link to="/Variations/about" onClick={() => setMenuOpen(false)}>
                <FaInfoCircle className="nav-icon" /> About Us
              </Link>
            </li>
            <li>
              <Link to="/Variations/pricing" onClick={() => setMenuOpen(false)}>
                <FaDollarSign className="nav-icon" /> Pricing
              </Link>
            </li>

            {isLoggedIn ? (
              <li>
                <button className="nav-btn logout-btn" onClick={handleLogout}>
                  <FaSignOutAlt className="nav-icon" /> Logout
                </button>
              </li>
            ) : (
              <li>
                <Link to="/login-User" className="nav-btn login-btn" onClick={() => setMenuOpen(false)}>
                  <FaSignInAlt className="nav-icon" /> Login
                </Link>
              </li>
            )}
          </ul>
        </nav>
      </header>
    </div>
  );
};

export default Header;
